import { Cid10, TipoAtestadoEnum } from 'graphql/types.generated'
import { conformToMask } from 'react-text-mask'
import { masks } from 'util/mask'
import { OBSERVACAO_DISABLE_EDIT_AND_REMOVE_ATESTADOS_TOOLTIP_TEXT } from 'view/atendimentos/atendimento-individual/atendimento-observacao/model-atendObservacao'

import { CidadaoAtestado } from './components/model-atestado'

export const ASSINATURA_CIDADAO_TEXT = 'ASSINATURA DO CIDADÃO OU RESPONSÁVEL'
export const CID10_DESCRICAO_ATESTADO = ', com o diagnóstico segundo CID10 '

export const NAO_E_POSSIVEL_EDITAR_ATESTADOS_GERADOS_DIGITALMENTE_E_ENVIADOS_TOOLTIP_TEXT =
  'Não é possível editar ou excluir atestados que foram gerados digitalmente e enviados ao cidadão'
export const ATESTADO_REGISTRADO_EM_OUTRO_ATENDIMENTO_TOOLTIP_TEXT = 'Atestado registrado em outro atendimento'
export const DEFAULT_ATESTADO_TOOLTIP_TEXT = 'Mais opções'

export const atestadoComCID10Text = ({ nomeCidadao, nomeProfissional }) =>
  `Eu, ${nomeCidadao.titleCase()}, autorizo o(a) Dr.(a) ${nomeProfissional} a registrar o diagnóstico codificado CID10 neste atestado.`

export const tituloAtestado = (tipoAtestado: TipoAtestadoEnum) =>
  tipoAtestado === TipoAtestadoEnum.LICENCA_MATERNIDADE ? 'LICENÇA MATERNIDADE' : 'ATESTADO'

export const getTooltipTextMaisOpcoesAtestado = (
  isAssinadoDigitalmente: boolean,
  isRegistroRecente: boolean,
  isEditable: boolean
): string => {
  if (isAssinadoDigitalmente && isRegistroRecente)
    return NAO_E_POSSIVEL_EDITAR_ATESTADOS_GERADOS_DIGITALMENTE_E_ENVIADOS_TOOLTIP_TEXT

  if (isEditable) return OBSERVACAO_DISABLE_EDIT_AND_REMOVE_ATESTADOS_TOOLTIP_TEXT

  if (!isRegistroRecente || isAssinadoDigitalmente) return ATESTADO_REGISTRADO_EM_OUTRO_ATENDIMENTO_TOOLTIP_TEXT

  return DEFAULT_ATESTADO_TOOLTIP_TEXT
}

export const buildCid10Substring = (cid10: Cid10 | undefined): string =>
  cid10 ? CID10_DESCRICAO_ATESTADO + cid10.codigo : ''

export const buildNomeSubstring = (cidadao: CidadaoAtestado): string =>
  cidadao.nomeSocial ? `${cidadao.nomeSocial} - (${cidadao.nome})` : cidadao.nome

const maskCpf = (cpf: string): string => conformToMask(cpf, masks.cpf, { guide: false }).conformedValue

export const buildCpfCnsSubstring = (
  cidadao: CidadaoAtestado,
  cpfCns: string | undefined,
  naoPossui: boolean | undefined
): string => {
  if (cidadao.cpf) return `portador(a) do CPF ${maskCpf(cidadao.cpf)}`
  if (cidadao.cns) return `portador(a) do CNS ${cidadao.cns}`
  if (naoPossui) return ''
  if (cpfCns?.length === 11) return `portador(a) do CPF ${maskCpf(cpfCns)}`
  if (cpfCns?.length === 15) return `portador(a) do CNS ${cpfCns}`

  return 'portador(a) do [CPF/CNS]'
}

export const buildDocumentoSubstring = (documento: string | undefined): string => (documento ? `, ${documento},` : '')
